import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import RequestIn from './RequestIn';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading,
    selectedRequest,
    courierSelected,
    error,
    message,
    validatedRequest,
  } = state.request;
  return {
    isLoading,
    selectedRequest,
    courierSelected,
    error,
    message,
    validatedRequest,
  };
}

const Styled = withStyles(styles)(RequestIn);

export default connect(
  mapStateToProps,
)(Styled);
